/**
 * File that can be imported to initialize global styles.
 */

import "reset-css";
import "@/assets/styles/tailwind.css";
import setupFontAwesome from "@/util/setupFontAwesome";

setupFontAwesome();
